import {
  saveUserKpiPreference,
  saveAndApply,
  setEditable,
  selectCreateNew,
  setSelectedKPIConfig,
} from '@store/overviewDashboard/spiThresholds/actions';
import { ALLOWED_KPIS_NUMBER, OVERVIEW_LABELS, CREATE_NEW_SPI_CONFIG } from '@src/utils/kpi';
import { setSelectedKPIId } from '@src/store/overviewDashboard/base/actions';

const onClickOfCreateNew = (dispatch, cancelEdit, selectedKPIConfig, validateKpiName) => {
  if (validateKpiName()) {
    dispatch(saveAndApply(selectedKPIConfig, cancelEdit));
    dispatch(selectCreateNew(false));
    dispatch(setEditable(false));
  }
};

const onClickOfSave = (
  pageType,
  dispatch,
  cancelEdit,
  selectedKPIConfig,
  validateKpiName,
  isEditable,
  isConfigChanged,
) => {
  if (pageType) {
    dispatch(setSelectedKPIId(selectedKPIConfig));
    cancelEdit();
    return;
  }

  const shouldEdit = isEditable && isConfigChanged();

  if (validateKpiName()) {
    dispatch(saveUserKpiPreference(selectedKPIConfig, cancelEdit, shouldEdit));
    dispatch(selectCreateNew(false));
    dispatch(setEditable(false));
  }
};

const validateKpiNameInUtil = (
  selectedKPIConfig,
  config,
  isBeingEdited,
  isCreateNewClicked,
  setValidKpiNameValid,
  setErrorMessage,
  isKpiNameValid,
) => {
  if (selectedKPIConfig) {
    const { kpiName } = selectedKPIConfig;
    const filteredConfig = config.filter((item) => item.kpiID !== selectedKPIConfig.kpiID);
    const existingKpiNames = filteredConfig.map((item) => item.kpiName.toLowerCase());
    if (isBeingEdited || isCreateNewClicked) {
      if (kpiName.length > 64) {
        setValidKpiNameValid(false);
        setErrorMessage(OVERVIEW_LABELS.ERROR_KPI_MAX_LENGTH);
        return isKpiNameValid;
      }
      if (kpiName && !existingKpiNames.includes(kpiName.toLowerCase())) {
        setValidKpiNameValid(true);
        return isKpiNameValid;
      }
      if (!kpiName) {
        setValidKpiNameValid(false);
        setErrorMessage(OVERVIEW_LABELS.ERROR_KPI_EMPTY);
        return isKpiNameValid;
      }
      setValidKpiNameValid(false);
      setErrorMessage(OVERVIEW_LABELS.ERROR_KPI_DUPLICATE);
      return isKpiNameValid;
    }
  }

  setValidKpiNameValid(true);
  return isKpiNameValid;
};

const closePopupAndResetState = (
  dispatch,
  selectedKPIConfigFromBase,
  setValidKpiNameValid,
  setErrorMessage,
  cancelEdit,
) => {
  // reset state
  dispatch(setSelectedKPIConfig(selectedKPIConfigFromBase));
  setValidKpiNameValid(true);
  setErrorMessage('');
  dispatch(setEditable(false));
  dispatch(selectCreateNew(false));
  cancelEdit();
};

const onClickOfBackButtonInAdminHeader = (config, selectedKPIConfigID, dispatch, showDropDown) => {
  const kpiConfig = config.find((item) => item.kpiID === selectedKPIConfigID);
  dispatch(setSelectedKPIConfig(kpiConfig));
  dispatch(setEditable(false));
  dispatch(selectCreateNew(false));
  showDropDown(true);
};

const onClickofCreateNewInAdminHeader = (config, setCreateNewError, dispatch, showDropDown) => {
  if (config.length >= ALLOWED_KPIS_NUMBER) {
    setCreateNewError(true);
    return;
  }
  dispatch(selectCreateNew(true));
  dispatch(setEditable(true));
  showDropDown(false);
  dispatch(setSelectedKPIConfig(CREATE_NEW_SPI_CONFIG));
};

const onClickOfDeleteInHeader = (
  isActiveKPI,
  dispatch,
  deleteCustomKPI,
  selectedKPIConfig,
  closeEditPopup,
  showDelete,
) => {
  if (isActiveKPI) {
    dispatch(deleteCustomKPI({ kpiId: selectedKPIConfig.kpiID }, closeEditPopup));
  } else {
    dispatch(deleteCustomKPI({ kpiId: selectedKPIConfig.kpiID }, null));
  }

  showDelete(false);
};

export {
  onClickOfCreateNew,
  onClickOfSave,
  validateKpiNameInUtil,
  closePopupAndResetState,
  onClickOfBackButtonInAdminHeader,
  onClickofCreateNewInAdminHeader,
  onClickOfDeleteInHeader,
};
